import { isString } from 'lodash-es'
import { type CountryCode, ALLOWED_CIS_COUNTRIES_WITHOUT_DOMAIN, COUNTRY_CODE } from './constants'

export type GetCountryFromUrlPayload = {
  routeCountryParam: unknown
  hostname: string
}

export const getCountryFromUrl = ({ routeCountryParam, hostname }: GetCountryFromUrlPayload): CountryCode | null => {
  const {
    applicationUrl,
    applicationUrlCis,
    applicationUrlAm,
    applicationUrlBy,
    applicationUrlGe,
    applicationUrlKg,
    applicationUrlKz,
    applicationUrlMd,
    applicationUrlTj,
    applicationUrlUz,
  } = useRuntimeConfig().public
  const toHostName = (url: string) => new URL(url).hostname

  switch (hostname) {
    case toHostName(applicationUrl):
      return COUNTRY_CODE.RU
    case toHostName(applicationUrlAm):
      return COUNTRY_CODE.AM
    case toHostName(applicationUrlBy):
      return COUNTRY_CODE.BY
    case toHostName(applicationUrlGe):
      return COUNTRY_CODE.GE
    case toHostName(applicationUrlKg):
      return COUNTRY_CODE.KG
    case toHostName(applicationUrlKz):
      return COUNTRY_CODE.KZ
    case toHostName(applicationUrlMd):
      return COUNTRY_CODE.MD
    case toHostName(applicationUrlTj):
      return COUNTRY_CODE.TJ
    case toHostName(applicationUrlUz):
      return COUNTRY_CODE.UZ
    case toHostName(applicationUrlCis):
      return isString(routeCountryParam)
        ? ALLOWED_CIS_COUNTRIES_WITHOUT_DOMAIN.find(iso => iso === routeCountryParam.toUpperCase()) ?? null
        : null
    default:
      return !import.meta.dev ? null : (useAppLocale().isRu ? COUNTRY_CODE.RU : COUNTRY_CODE.BY)
  }
}
